import React from 'react';

export const Confirmation = (props) => {
  return (
    <div id="modal" className="dialog">
      <h3>Remove Item?</h3>
      <button
        type="button"
        className="sb-btn sb-btn-save"
        onClick={() => {
          props.showConfirmation.remove();
          props.setShowConfirmation({
            display: false,
            target: null,
            remove: {},
          });
        }}
      >
        Confirm
      </button>
      <button
        type="button"
        className="sb-btn sb-btn-cancel"
        onClick={() =>
          props.setShowConfirmation({
            display: false,
            target: null,
            remove: {},
          })
        }
      >
        Cancel
      </button>
    </div>
  );
};

export default Confirmation;
